import React, { useState } from "react";
import Widget from "components/Widget/Widget";
import FormPreview from "./FormPreview/FormPreview";
import FormSettings from "./FormSettings/FormSettings";

import { FormBuilderProvider } from "./FormBuilderContext";

import "./FormBuilder.less";
import FormsList from "./FormsList/FormsList";
import SettingsModal from "../../Modal/SettingsModal";
import { ListBuilderProvider } from "../../../context/ListBuilderContext/ListBuilderContext";

const FormBuilder = ({ value, role }) => {
   const [isModalOpen, setIsModalOpen] = useState(false);

   return (
      <ListBuilderProvider>
         <FormBuilderProvider>
            <Widget
               title={value.name}
               overflow={"visible"}
               bgColor={value.backgroundColourHex}
               role={role}
               extra={
                  (role === "OWNER" || role === "MODERATOR") && (
                     <SettingsModal
                        widgetName={value.name}
                        widgetId={value.id}
                        icon="setting"
                        deleteIcon="true"
                        setIsOpen={setIsModalOpen}
                        isModalOpen={isModalOpen}
                     >
                        <FormSettings setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
                     </SettingsModal>
                  )
               }
            >
               <FormSettings setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
               <div className="form-builder-wrapper">
                  <FormPreview />
               </div>

               <FormsList />
            </Widget>
         </FormBuilderProvider>
      </ListBuilderProvider>
   );
};

export default FormBuilder;
